import * as R from 'ramda';

export const getPromo = R.identity;
